import { createStore } from 'owa-satcheljs';
import type { AddinCommandSurfaceItem } from 'owa-addins-types';

type AddinSurfaceCache = Map<string, AddinCommandSurfaceItem | undefined>;
type SurfaceFlags = Map<'MessageRead' | 'MessageCompose' | 'MultipleSelection', boolean>;

interface AddinSurfaceStore {
    cache: AddinSurfaceCache;
    surfaceFlags: SurfaceFlags;
}

/**
 * Store to cache add-in command surface items
 */
export const getAddinSurfaceStore: () => AddinSurfaceStore = createStore<AddinSurfaceStore>(
    'addinSurfaceStore',
    {
        cache: new Map(),
        surfaceFlags: new Map([
            ['MessageRead', false],
            ['MessageCompose', false],
            ['MultipleSelection', false],
        ]),
    }
);
